import { gql } from '@apollo/client'
import GolferProfileFragment from 'fragments/student/golferProfile'

export const GET_STUDENT_QUERY = gql`
  ${GolferProfileFragment}
  query Student($id: ID!) {
    student(id: $id) {
      id
      isMinor
      firstName
      lastName
      medicalProfile {
        info
      }
      contact {
        id
        firstName
        lastName
        email
        phone
      }
      representatives {
        id
        relationshipType
        contact {
          id
          firstName
          lastName
          email
          phone
        }
      }
      golferProfile {
        ...GolferProfileAttributes
      }
    }
  }
`

export const DELETE_REPRESENTATIVE = gql`
  mutation DeleteRepresentative($representativeId: ID!) {
    deleteRepresentative(representativeId: $representativeId) {
      message
      success
    }
  }
`
